export default __webpack_public_path__ + "static/media/Analytics-icon.ff282804.svg";